/* eslint-disable max-lines */
import VueButton from '@ui-common/vue-button';
import VueCaptcha from '@ui-common/vue-captcha';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueFeedback from '@ui-common/vue-feedback';
import VueFormNotification from '@ui-common/vue-form-notification';
import VueInput from '@ui-common/vue-input';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueSpinner from '@ui-common/vue-spinner';
import VueTooltip from '@ui-common/vue-tooltip';
import { errorHandlerUtils } from '../../common/error-handler-utils/error-handler-utils';
import phonenumberInput from '../phonenumber-input/phonenumber-input.vue';
import selectBox from '../select-box/select-box.vue';
import tabbable from '../../common/tabbable/tabbable';
import eventBus from '../../common/event-bus/event-bus';
import { useRating } from '../../common/composables/rating';

export default {
	setup() {
		const { ratingUnavailable, setRatingClosed, showPrecedingForm, ratingSuccess } = useRating();
		return { ratingUnavailable, setRatingClosed, showPrecedingForm, ratingSuccess };
	},
	data() {
		return {
			showCallbackRequest: false,
			invalidCaptcha: false,
			timeText: null,
			model: {
				name: '',
				phoneNumber: '',
				email: '',
				captcha: '',
				time: null,
				captchaToken: null,
				other: null,
				callbackSubject: null
			},
			labels: {
				name: {
					label: null,
					requiredError: null,
					patternError: null,
					minLengthError: null
				},
				phoneNumber: {
					label: null,
					requiredError: null,
					patternError: null
				}
			}
		};
	},
	props: [
		'captcha',
		'captchaError',
		'gaCategory',
		'id',
		'loading',
		'openInModal',
		'privacyPolicyUrl',
		'productId',
		'questionId',
		'sendCoupon',
		'sendFailed',
		'sendSucceeded',
		'technicalError',
		'timetable',
		'type',
		'callbackSubjects'
	],
	mixins: [tabbable, errorHandlerUtils],
	watch: {
		'model.time'(val) {
			if (val && this.timetable) {
				this.timeText = this.timetable.find(item => item.id == val).description;
			}
		},
		isModalOpened(val) {
			if (typeof this.modalVisibilityChange == 'function') {
				this.modalVisibilityChange(val, this.modalId);
			}
		},
		timetable() {
			this.setFirstTime();
		},
		captchaError(val) {
			this.invalidCaptcha = val;
			if (val) {
				this.model.captcha = null;
			}
		},
		sendSucceeded(val) {
			if (val) {
				this.$nextTick(() => {
					if (this.$refs.successHeader) {
						this.$refs.successHeader.focus();
					}
				});
			}
		},
		sendFailed(val) {
			if (val) {
				this.$nextTick(() => {
					if (this.$refs.failedHeader) {
						this.$refs.failedHeader.focus();
					}
				});
			}
		},
		captcha(val) {
			if (val && val.htmlFragment) {
				this.$gtm.trackEvent({
					event: 'callbackRequestShownWithCaptcha'
				});
			}
		}
	},
	components: {
		VueButton,
		VueCaptcha,
		VueErrorMessage,
		VueFeedback,
		VueFormNotification,
		VueInput,
		VueMaskedInput,
		VueMobilephoneInput,
		VueSelect,
		VueSelectOption,
		VueSpinner,
		VueTooltip,
		phonenumberInput,
		selectBox
	},
	methods: {
		setFirstTime() {
			if (this.timetable && this.timetable.length) {
				this.model.time = this.timetable[0].id;
			}
		},
		sendCallRequest() {
			this.invalidCaptcha = false;
			this.$v.$touch();
			if (!this.$v.$invalid) {
				let sendModel = Object.assign({}, this.model);
				this.$emit('on-send-callrequest', sendModel);
			}
		},
		closePopup() {
			const event = new CustomEvent('call-request-close-modal', { detail: { id: this.id } });
			window.dispatchEvent(event);
		},
		modalVisibilityChange(val, modalId) {
			if (window.portalEventBus) {
				window.portalEventBus.$emit('changeModalType', { modalType: val ? 'narrow' : null, modalId });
			}
		},
		resetForm() {
			this.resetMainFields();
		},
		resetMainFields() {
			this.model.name = '';
			this.model.phoneNumber = '';
			this.model.email = '';
			this.model.callbackSubject = null;
			this.model.captcha = '';
			this.model.captchaToken = null;
			this.$v.$reset();
		}
	},
	computed: {
		isModalOpened() {
			return this.sendSucceeded || this.sendFailed;
		},
		componentName() {
			return this.$vnode.tag.replace(/vue-component-\d+-/i, '');
		},
		isBusinessType() {
			return this.type == 'BUSINESS';
		},
		nameLabel() {
			if (this.labels.name.label) {
				return this.labels.name.label;
			} else {
				return this.isBusinessType ? 'Kapcsolattartó neve' : this.$t('name.label');
			}
		},
		nameErrorRequired() {
			if (this.labels.name.requiredError) {
				return this.labels.name.requiredError;
			} else {
				return this.isBusinessType ? this.$t('name.requiredErrorBusiness') : this.$t('name.requiredError');
			}
		},
		nameErrorPattern() {
			return this.labels.name.patternError || this.$t('name.patternError');
		},
		nameErrorMinLength() {
			return this.labels.name.minLengthError || this.$t('name.patternError');
		},
		phoneNumberLabel() {
			return this.labels.phoneNumber.label || this.$t('phoneNumber.label');
		},
		phoneNumberRequired() {
			return this.labels.phoneNumber.requiredError || this.$t('phoneNumber.requiredError');
		},
		phoneNumberPattern() {
			return this.labels.phoneNumber.patternError || this.$t('phoneNumber.patternError');
		},
		emailAddon() {
			if (this.sendCoupon) {
				return 'Az online kamatkedvezmény-kupont erre a címre küldjük.';
			} else if (this.type == 'FINANCIALPLANNING') {
				return '(Opcionális)';
			}
			return '';
		},
		hasRating() {
			return this.$slots.rating && this.$slots.rating[0] && this.$slots.rating[0].data && this.$slots.rating[0].data.domProps && !!this.$slots.rating[0].data.domProps.innerHTML;
		}
	},
	created() {
		this.model.productId = this.productId;
		this.model.questionId = this.questionId;
		this.showCallbackRequest = true;
		this.setFirstTime();
		eventBus.$on('reset-form', () => {
			this.resetForm();
		});
	}
};
